module.exports = __webpack_public_path__ + "img/bubbles.11b95b46.svg";